/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "pa-Arab": {
        "nu": ["arabext"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "year-narrow": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-narrow": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "month-narrow": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "week-narrow": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "day": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "yesterday"
        },
        "day-short": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "yesterday"
        },
        "day-narrow": {
          "0": "today",
          "1": "tomorrow",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "yesterday"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        }
      },
      "pa": {
        "nu": ["latn"],
        "year": {
          "0": "ਇਹ ਸਾਲ",
          "1": "ਅਗਲਾ ਸਾਲ",
          "future": {
            "one": "{0} ਸਾਲ ਵਿੱਚ",
            "other": "{0} ਸਾਲਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਸਾਲ ਪਹਿਲਾਂ",
            "other": "{0} ਸਾਲ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਸਾਲ"
        },
        "year-short": {
          "0": "ਇਹ ਸਾਲ",
          "1": "ਅਗਲਾ ਸਾਲ",
          "future": {
            "one": "{0} ਸਾਲ ਵਿੱਚ",
            "other": "{0} ਸਾਲਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਸਾਲ ਪਹਿਲਾਂ",
            "other": "{0} ਸਾਲ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਸਾਲ"
        },
        "year-narrow": {
          "0": "ਇਹ ਸਾਲ",
          "1": "ਅਗਲਾ ਸਾਲ",
          "future": {
            "one": "{0} ਸਾਲ ਵਿੱਚ",
            "other": "{0} ਸਾਲਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਸਾਲ ਪਹਿਲਾਂ",
            "other": "{0} ਸਾਲ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਸਾਲ"
        },
        "quarter": {
          "0": "ਇਸ ਤਿਮਾਹੀ",
          "1": "ਅਗਲੀ ਤਿਮਾਹੀ",
          "future": {
            "one": "{0} ਤਿਮਾਹੀ ਵਿੱਚ",
            "other": "{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ",
            "other": "{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲੀ ਤਿਮਾਹੀ"
        },
        "quarter-short": {
          "0": "ਇਹ ਤਿਮਾਹੀ",
          "1": "ਅਗਲੀ ਤਿਮਾਹੀ",
          "future": {
            "one": "{0} ਤਿਮਾਹੀ ਵਿੱਚ",
            "other": "{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ",
            "other": "{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲੀ ਤਿਮਾਹੀ"
        },
        "quarter-narrow": {
          "0": "ਇਹ ਤਿਮਾਹੀ",
          "1": "ਅਗਲੀ ਤਿਮਾਹੀ",
          "future": {
            "one": "{0} ਤਿਮਾਹੀ ਵਿੱਚ",
            "other": "{0} ਤਿਮਾਹੀਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਤਿਮਾਹੀ ਪਹਿਲਾਂ",
            "other": "{0} ਤਿਮਾਹੀਆਂ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲੀ ਤਿਮਾਹੀ"
        },
        "month": {
          "0": "ਇਹ ਮਹੀਨਾ",
          "1": "ਅਗਲਾ ਮਹੀਨਾ",
          "future": {
            "one": "{0} ਮਹੀਨੇ ਵਿੱਚ",
            "other": "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
            "other": "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਮਹੀਨਾ"
        },
        "month-short": {
          "0": "ਇਹ ਮਹੀਨਾ",
          "1": "ਅਗਲਾ ਮਹੀਨਾ",
          "future": {
            "one": "{0} ਮਹੀਨੇ ਵਿੱਚ",
            "other": "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
            "other": "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਮਹੀਨਾ"
        },
        "month-narrow": {
          "0": "ਇਹ ਮਹੀਨਾ",
          "1": "ਅਗਲਾ ਮਹੀਨਾ",
          "future": {
            "one": "{0} ਮਹੀਨੇ ਵਿੱਚ",
            "other": "{0} ਮਹੀਨਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਮਹੀਨਾ ਪਹਿਲਾਂ",
            "other": "{0} ਮਹੀਨੇ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਮਹੀਨਾ"
        },
        "week": {
          "0": "ਇਹ ਹਫ਼ਤਾ",
          "1": "ਅਗਲਾ ਹਫ਼ਤਾ",
          "future": {
            "one": "{0} ਹਫ਼ਤੇ ਵਿੱਚ",
            "other": "{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ",
            "other": "{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਹਫ਼ਤਾ"
        },
        "week-short": {
          "0": "ਇਹ ਹਫ਼ਤਾ",
          "1": "ਅਗਲਾ ਹਫ਼ਤਾ",
          "future": {
            "one": "{0} ਹਫ਼ਤੇ ਵਿੱਚ",
            "other": "{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ",
            "other": "{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਹਫ਼ਤਾ"
        },
        "week-narrow": {
          "0": "ਇਹ ਹਫ਼ਤਾ",
          "1": "ਅਗਲਾ ਹਫ਼ਤਾ",
          "future": {
            "one": "{0} ਹਫ਼ਤੇ ਵਿੱਚ",
            "other": "{0} ਹਫ਼ਤਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਹਫ਼ਤਾ ਪਹਿਲਾਂ",
            "other": "{0} ਹਫ਼ਤੇ ਪਹਿਲਾਂ"
          },
          "-1": "ਪਿਛਲਾ ਹਫ਼ਤਾ"
        },
        "day": {
          "0": "ਅੱਜ",
          "1": "ਭਲਕੇ",
          "future": {
            "one": "{0} ਦਿਨ ਵਿੱਚ",
            "other": "{0} ਦਿਨਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਦਿਨ ਪਹਿਲਾਂ",
            "other": "{0} ਦਿਨ ਪਹਿਲਾਂ"
          },
          "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ"
        },
        "day-short": {
          "0": "ਅੱਜ",
          "1": "ਭਲਕੇ",
          "future": {
            "one": "{0} ਦਿਨ ਵਿੱਚ",
            "other": "{0} ਦਿਨਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਦਿਨ ਪਹਿਲਾਂ",
            "other": "{0} ਦਿਨ ਪਹਿਲਾਂ"
          },
          "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ"
        },
        "day-narrow": {
          "0": "ਅੱਜ",
          "1": "ਭਲਕੇ",
          "future": {
            "one": "{0} ਦਿਨ ਵਿੱਚ",
            "other": "{0} ਦਿਨਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਦਿਨ ਪਹਿਲਾਂ",
            "other": "{0} ਦਿਨ ਪਹਿਲਾਂ"
          },
          "-1": "ਬੀਤਿਆ ਕੱਲ੍ਹ"
        },
        "hour": {
          "0": "ਇਸ ਘੰਟੇ",
          "future": {
            "one": "{0} ਘੰਟੇ ਵਿੱਚ",
            "other": "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
            "other": "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
          }
        },
        "hour-short": {
          "0": "ਇਸ ਘੰਟੇ",
          "future": {
            "one": "{0} ਘੰਟੇ ਵਿੱਚ",
            "other": "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
            "other": "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
          }
        },
        "hour-narrow": {
          "0": "ਇਸ ਘੰਟੇ",
          "future": {
            "one": "{0} ਘੰਟੇ ਵਿੱਚ",
            "other": "{0} ਘੰਟਿਆਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਘੰਟਾ ਪਹਿਲਾਂ",
            "other": "{0} ਘੰਟੇ ਪਹਿਲਾਂ"
          }
        },
        "minute": {
          "0": "ਇਸ ਮਿੰਟ",
          "future": {
            "one": "{0} ਮਿੰਟ ਵਿੱਚ",
            "other": "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
            "other": "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
          }
        },
        "minute-short": {
          "0": "ਇਸ ਮਿੰਟ",
          "future": {
            "one": "{0} ਮਿੰਟ ਵਿੱਚ",
            "other": "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
            "other": "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
          }
        },
        "minute-narrow": {
          "0": "ਇਸ ਮਿੰਟ",
          "future": {
            "one": "{0} ਮਿੰਟ ਵਿੱਚ",
            "other": "{0} ਮਿੰਟਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਮਿੰਟ ਪਹਿਲਾਂ",
            "other": "{0} ਮਿੰਟ ਪਹਿਲਾਂ"
          }
        },
        "second": {
          "0": "ਹੁਣ",
          "future": {
            "one": "{0} ਸਕਿੰਟ ਵਿੱਚ",
            "other": "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
            "other": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
          }
        },
        "second-short": {
          "0": "ਹੁਣ",
          "future": {
            "one": "{0} ਸਕਿੰਟ ਵਿੱਚ",
            "other": "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
            "other": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
          }
        },
        "second-narrow": {
          "0": "ਹੁਣ",
          "future": {
            "one": "{0} ਸਕਿੰਟ ਵਿੱਚ",
            "other": "{0} ਸਕਿੰਟਾਂ ਵਿੱਚ"
          },
          "past": {
            "one": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ",
            "other": "{0} ਸਕਿੰਟ ਪਹਿਲਾਂ"
          }
        }
      }
    },
    "availableLocales": ["pa-Arab", "pa-Guru", "pa"],
    "aliases": {
      "pa-IN": "pa-Guru-IN",
      "pa-PK": "pa-Arab-PK"
    },
    "parentLocales": {}
  });
}